import { escapeHtml } from "../../../../util/string";

// restituisce HTML (reso con dangerouslySetInnerHTML): i dati vanno sempre passati da escapeHtml
export function getFormattedAddress(item, includeBr = true) {
   const { address, zip_code, comune, province } = item || {};

   let tokens = [];
   if (address && address.trim() !== "") {
      tokens.push(escapeHtml(address) + (includeBr ? "<br />" : ""));
   }

   if (zip_code && zip_code.trim() !== "") tokens.push(escapeHtml(zip_code));

   if (comune?.description) {
      if (tokens.length > 0) {
         tokens.push("-");
      }
      tokens.push(escapeHtml(comune.description));
   }

   if (province?.description) {
      if (tokens.length > 0) {
         tokens.push("-");
      }
      tokens.push(escapeHtml(province.description));
   }

   return tokens.join(" ").replace("<br /> ", "<br />");
}

export function sortTaxAccountsByCode(taxAccounts) {
   if (!Array.isArray(taxAccounts)) return [];
   return taxAccounts.slice().sort((a, b) => {
      if (a.code < b.code) return -1;
      if (a.code > b.code) return 1;
      return 0;
   });
}

export function taxAccountHaveFormItems(taxAccountId, form) {
   if (!form || !Array.isArray(form)) return false;
   const taxAccountForm = form.find((f) => f.tax_account_id === taxAccountId);
   return (
      taxAccountForm &&
      Array.isArray(taxAccountForm.items) &&
      taxAccountForm.items.length > 0
   );
}

export function getCustomerCompletionPercentage(taxAccounts, form) {
   if (!Array.isArray(taxAccounts) || taxAccounts.length === 0) return 0;
   const total = taxAccounts.length;
   const completed = taxAccounts.filter((ta) =>
      taxAccountHaveFormItems(ta.id, form)
   ).length;

   return Math.round((completed / total) * 100);
}
